import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Trustedecommerceweb() {
  return (
    <section className="trusted_ecommerce_web p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Why is SEO Strategy the Key to the <span>Digital Growth</span> of
              Your Business?
            </h2>
            <p>
              In this regard, having a proper SEO approach is crucial for any
              business when it comes to digital marketing strategies. Not only
              does it help you get more internet exposure but it also ensures
              that your brand is circulating effectively in a constantly
              changing market.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <Row className="mt-3 mt-md-4">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>Improves Visibility & Rankings</h5>
                    <p>
                      Effective SEO ensures that your website ranks high with
                      search engines hence enabling the potential customers to
                      find you easily. With a higher ranking of a website, it is
                      easy to target a specific niche audience and thus
                      eliminate the competition.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>Drives Web Traffic</h5>
                    <p>
                      SEO assists you in ranking your site for better organic
                      traffic because it focuses on the right keywords and
                      content. The increased traffic to your site also enhances
                      the opportunity to convert visitors into customers, thus,
                      fostering sustainable traffic.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                className="mb-md-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>Shows Authority</h5>
                    <p>
                       An effective SEO plan and strategy position your business
                      as the go-to source of information on products and
                      services within a particular market. By regularly
                      occupying the first pages and offering relevant content,
                      you gain the trust of the audience and strengthen its
                      recognition of your competence.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>Enhances Customer Experience</h5>
                    <p>
                      One of the important things to understand is that SEO is
                      not only a method of working with search engines, but also
                      with users. As such, aspects like site speed and mobile
                      responsiveness improve the overall experience of site
                      visitors, which in turn can improve conversion rates and
                      satisfaction levels.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Trustedecommerceweb;
